export default __webpack_public_path__ + "static/media/Jae.c4ac4c79.jpg";